import * as Sentry from '@sentry/react';
import { ButtonGroup } from '@ui-components/neo.tax';
import * as React from 'react';

import { useUpdateCompanyQuestion, ChoiceCode } from '@neo.tax/shared';

import { MissingAvailableChoices } from './company-info.errors';
import { QuestionProps } from './company-info.types';

export const ButtonField: React.FC<QuestionProps> = ({ question }) => {
  const updateCompanyQuestion = useUpdateCompanyQuestion(question.id, question.questionId);

  if (!question.questionChoices) {
    Sentry.captureException(new MissingAvailableChoices(question));
    return null;
  }

  const { questionChoices, questionCode } = question;

  return (
    <ButtonGroup
      id={questionCode}
      options={questionChoices.map(({ choiceCode, displayText }) => ({
        value: choiceCode,
        label: displayText,
      }))}
      value={questionChoices.find(({ selected }) => selected)?.choiceCode}
      onClick={(newChoiceCode: ChoiceCode): void => {
        updateCompanyQuestion({ answerValues: newChoiceCode, questionCode: question.questionCode });
      }}
    />
  );
};
